'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DefaultButton = require('./components/DefaultButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DefaultButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/buttons/lib/components/default/index.js
// module id = 216
// module chunks = 0 1 3 4 5